import { useState } from 'react';
import Input from '../../components/Input';
import PageHeader from '../../components/PageHeader';

import { useNavigate } from 'react-router';
import Button from '../../components/Button';
import PhoneInput from '../../components/PhoneInput/PhoneInput';
import AppConfig from '../../config';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import './EditCardPersonalInfo.scss';

let MOCK_DATA = {
	name: 'Volodymyr',
	surname: 'Kozak',
	email: 'kozakvolodymyr21@gmail.com',
	phone: '+380502533371',
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\+\d{8,15}$/;

const { routes } = AppConfig;

const EditCardPersonalInfo = () => {
	const [name, setName] = useState(MOCK_DATA.name);
	const [surname, setSurname] = useState(MOCK_DATA.surname);
	const [email, setEmail] = useState(MOCK_DATA.email);
	const [phone, setPhone] = useState(MOCK_DATA.phone);

	const initialData = MOCK_DATA;

	const isChanged =
		name !== initialData.name ||
		surname !== initialData.surname ||
		email !== initialData.email ||
		phone !== initialData.phone;

	const isValid = name.trim() && surname.trim() && emailRegex.test(email) && phoneRegex.test(phone);
	const isButtonDisabled = !isChanged || !isValid;

	// Временно пока бека нету
	const isEmailChanged = email !== initialData.email;
	const isPhoneChanged = phone !== initialData.phone;

	const navigate = useNavigate();

	const testEdit = () => {
		MOCK_DATA = {
			name,
			surname,
			email,
			phone,
		};

		console.log('MOCK_DATA updated: ', MOCK_DATA);
	};
	//

	const resolveFunct = () => {
		navigate(-1);
		HelperService.showNotification({
			type: 'success',
			title: t('Successful'),
			description: 'Personal info has been changed',
		});
	};

	const rejectFunct = () => {
		navigate(-1);
		HelperService.showNotification({
			type: 'error',
			title: t('Error'),
		});
	};

	const editInfo = async () => {
		try {
			// заглушка ответа от сервера
			const mockResponse = {
				EmailVerificationError: isEmailChanged,
				PhoneVerificatioNError: isPhoneChanged,
			};

			if (mockResponse.EmailVerificationError || mockResponse.PhoneVerificatioNError) {
				HelperService.verifyEmailPhone({
					verificationEmail: mockResponse.EmailVerificationError,
					verificationPhone: mockResponse.PhoneVerificatioNError,
					successNotifficationText: 'Success',
					successRedirectRoute: routes.allCards,
				});
				return;
			}
		} catch (e) {
			console.log(e);
		}
	};

	return (
		<div className='EditCardPersonalInfo'>
			<PageHeader header='Edit Info' />
			<div className='EditCardPersonalInfo__body'>
				<div className='EditCardPersonalInfo__form'>
					<Input
						className='EditCardPersonalInfo___input FormBlock'
						value={name}
						onChange={e => setName(e.target.value)}
					/>
					<Input
						className='EditCardPersonalInfo___input FormBlock'
						value={surname}
						onChange={e => setSurname(e.target.value)}
					/>
					<Input
						className='EditCardPersonalInfo___input FormBlock'
						value={email}
						onChange={e => setEmail(e.target.value)}
					/>
					<PhoneInput value={phone} onChange={setPhone} />
				</div>
				<Button className='EditCardPersonalInfo__button' disabled={isButtonDisabled} onClick={editInfo}>
					Save changes
				</Button>
			</div>
		</div>
	);
};

export default EditCardPersonalInfo;
